import NextLink from 'next/link';
import { Button, PopOut, buttonClass } from '@goodneighbor/ui';
import styles from './link.module.scss';
import { cva, type VariantProps } from 'class-variance-authority';

const sizeVariants = {
  large: styles.large,
  medium: styles.medium,
  small: styles.small,
  xsmall: styles.xsmall
} as const;

export const linkClass = cva(styles.link, {
  variants: {
    size: sizeVariants
  },
  defaultVariants: {
    size: 'medium'
  }
});

type LinkProps = VariantProps<typeof linkClass> &
  React.ComponentPropsWithoutRef<typeof NextLink> & {
    external?: boolean;
    asButton?: boolean;
    buttonProps?: React.ComponentPropsWithoutRef<typeof Button>;
  };

export default function Link({
  className,
  size = 'medium',
  external = false,
  children,
  asButton,
  buttonProps,
  ...props
}: LinkProps) {
  if (asButton) {
    return (
      <NextLink
        className={buttonClass({ className, ...buttonProps })}
        {...props}
      >
        {children}
      </NextLink>
    );
  }

  if (external) {
    return (
      <NextLink
        className={linkClass({ className, size })}
        {...props}
        target="_blank"
        rel="noopener noreferrer"
      >
        {children}
        <PopOut className={styles.externalLink} />
      </NextLink>
    );
  }
  return (
    <NextLink className={linkClass({ className, size })} {...props}>
      {children}
    </NextLink>
  );
}
